import React from "react";
import {
  X,
  Calendar,
  Star,
  Home,
  TrendingUp,
  GraduationCap,
} from "lucide-react";
import { palette, styles } from "../theme";

const Sidebar = ({ isMobile, sidebarOpen, setSidebarOpen, tab, setTab }) => {
  return (
    <>
      {isMobile && sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 40,
          }}
        />
      )}

      <aside
        style={
          isMobile
            ? {
                ...styles.sidebarMobile,
                transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)",
              }
            : styles.sidebarDesktop
        }
      >
        {isMobile && (
          <button
            onClick={() => setSidebarOpen(false)}
            style={{
              position: "absolute",
              top: 16,
              right: 16,
              background: "transparent",
              border: "none",
              color: "#FFF",
            }}
          >
            <X size={24} />
          </button>
        )}

        <div style={{ marginBottom: "60px", paddingLeft: "14px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div
              style={{
                width: 12,
                height: 12,
                background: palette.gold,
                borderRadius: "50%",
              }}
            />
            <div>
              <div
                style={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: "#FFFFFF",
                  letterSpacing: "0.15em",
                  textTransform: "uppercase",
                }}
              >
                THE PLAN
              </div>
            </div>
          </div>
        </div>
        <nav
          style={{ flex: 1, display: "flex", flexDirection: "column", gap: 8 }}
        >
          <div
            style={styles.navItem(tab === "tracker")}
            onClick={() => {
              setTab("tracker");
              if (isMobile) setSidebarOpen(false);
            }}
          >
            <Calendar size={18} /> <span>Planner</span>
          </div>

          {/* NEW ADOBE LEARNING TAB */}
          <div
            style={styles.navItem(tab === "adobe")}
            onClick={() => {
              setTab("adobe");
              if (isMobile) setSidebarOpen(false);
            }}
          >
            <GraduationCap size={18} /> <span>Adobe Learning</span>
          </div>

          <div
            style={styles.navItem(tab === "goals")}
            onClick={() => {
              setTab("goals");
              if (isMobile) setSidebarOpen(false);
            }}
          >
            <Star size={18} /> <span>Q1 Goals</span>
          </div>
          <div
            style={styles.navItem(tab === "family")}
            onClick={() => {
              setTab("family");
              if (isMobile) setSidebarOpen(false);
            }}
          >
            <Home size={18} /> <span>Household</span>
          </div>
        </nav>

        <div
          style={{
            marginTop: "auto",
            padding: 20,
            background: "rgba(255,255,255,0.05)",
            borderRadius: 8,
            border: "1px solid rgba(255,255,255,0.05)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 8,
            }}
          >
            <TrendingUp size={14} color={palette.gold} />
            <span
              style={{
                fontSize: 11,
                fontWeight: 600,
                color: palette.gold,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              Jan Presentation
            </span>
          </div>
          <div
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "#fff",
              fontFamily: "serif",
            }}
          >
            On Track
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
